import React from "react";
import { ReactComponent as Developer } from "../../assets/img/development.svg";
import { HomeSection } from "./styles";
import { pageMotion } from "../../framer/animation";
import SliderPage from "../../components/SliderPage/SliderPage";
import { Link } from "react-router-dom";

function Home() {
	return (
		<>
			<SliderPage />
			<HomeSection
				variants={pageMotion}
				initial='hidden'
				animate='show'
				exit='exit'
			>
				<div className='brief-info'>
					<h1>
						Hi, I'm Amir.
						<br />
						Junior Front-End Developer &
						<br />
						Something of a UI Designer.
					</h1>
					<button>
						<Link to='about'>About me</Link>
					</button>
				</div>

				<div className='image'>
					<div className='overlay'></div>
					<Developer />
				</div>
			</HomeSection>
		</>
	);
}

export default Home;
